export function vehicleProgressStatus(v) {
    if (!v) {
        return null;
    }
    if (v.completed || v.completedDateTime) {
        return { key: 'completed', label: 'Completed', at: v.completedDateTime || null };
    }
    if (v.turnAroundTime) {
        return { key: 'turnedAround', label: 'Turned around', at: v.turnAroundTime };
    }
    if (v.actualDepartDateTime) {
        return { key: 'enRoute', label: 'En route', at: v.actualDepartDateTime };
    }
    if (v.pickedUpDateTime) {
        return { key: 'pickedUp', label: 'Picked up', at: v.pickedUpDateTime };
    }
    return null;
}

const PROGRESS_MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

/** Local status time, e.g. "Nov 2, 3:45:07 PM". Built by hand so seconds do not pull in a year or a special space. */
export function formatProgressTime(at) {
    if (!at) {
        return '';
    }
    const d = new Date(at);
    if (Number.isNaN(d.getTime())) {
        return '';
    }
    let hours = d.getHours();
    const suffix = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12 || 12;
    const pad = (n) => String(n).padStart(2, '0');
    return `${PROGRESS_MONTHS[d.getMonth()]} ${d.getDate()}, ${hours}:${pad(d.getMinutes())}:${pad(d.getSeconds())} ${suffix}`;
}

export function progressModifier(key) {
    return {
        pickedUp: 'pickedup',
        enRoute: 'enroute',
        turnedAround: 'turned',
        completed: 'completed',
    }[key] || '';
}
